/**
 * 用户使用习惯（mid=10）
 * 字段顺序与 cg_v3_data `UserUseRember` 的 `@DataStrucrParse` order 1～34 一致；boolean 使用 readBool/writeBool。
 */
import { FileReader, FileWriter } from '@/platform'
import ModuleId from './DataStructModuleId'
import PersonSetting from './GameSystemData/PersonSetting'
import CompressFile from './UserUse/CompressFile'
import BubbleRegion from './UserUse/BubbleRegion'
import DataUtils from './DataUtils'
import Hashtable from './Hashtable'

export class NameOfColor {
    public Name = ''
    public Color = ''
    readBin(reader: FileReader): void {
        this.Name = reader.readString()
        this.Color = reader.readString()
    }
    writeBin(writer: FileWriter): void {
        writer.writeString(this.Name)
        writer.writeString(this.Color)
    }
}

export class NumberName {
    public ID = 0
    public name = ''
    readBin(reader: FileReader): void {
        this.ID = reader.readInt()
        this.name = reader.readString()
    }
    writeBin(writer: FileWriter): void {
        writer.writeInt(this.ID)
        writer.writeString(this.name)
    }
}

enum MaterialShowMode {
    LargeIcon = 0,
    List = 1,
}

function readStringList(reader: FileReader): string[] {
    const n = reader.readInt()
    const a: string[] = []
    for (let i = 0; i < n; i++) {
        a.push(reader.readString())
    }
    return a
}

function writeStringList(writer: FileWriter, a: string[]): void {
    writer.writeInt(a.length)
    for (let i = 0; i < a.length; i++) {
        writer.writeString(a[i] ?? '')
    }
}

function readStringMatrix(reader: FileReader): string[][] {
    const n = reader.readInt()
    const out: string[][] = []
    for (let i = 0; i < n; i++) {
        const m = reader.readInt()
        const row: string[] = []
        for (let j = 0; j < m; j++) {
            row.push(reader.readString())
        }
        out.push(row)
    }
    return out
}

function writeStringMatrix(writer: FileWriter, m: string[][]): void {
    writer.writeInt(m.length)
    for (let r = 0; r < m.length; r++) {
        const row = m[r] ?? []
        writer.writeInt(row.length)
        for (let c = 0; c < row.length; c++) {
            writer.writeString(row[c] ?? '')
        }
    }
}

function readNameOfColorList(reader: FileReader): NameOfColor[] {
    const n = reader.readInt()
    const list: NameOfColor[] = []
    for (let i = 0; i < n; i++) {
        const c = new NameOfColor()
        c.readBin(reader)
        list.push(c)
    }
    return list
}

function writeNameOfColorList(writer: FileWriter, list: NameOfColor[]): void {
    writer.writeInt(list.length)
    for (let i = 0; i < list.length; i++) {
        list[i]!.writeBin(writer)
    }
}

function readPersonSettingList(reader: FileReader): PersonSetting[] {
    const n = reader.readInt()
    const list: PersonSetting[] = []
    for (let i = 0; i < n; i++) {
        const p = new PersonSetting(undefined as unknown as FileReader)
        p.readBin(reader)
        list.push(p)
    }
    return list
}

function writePersonSettingList(writer: FileWriter, list: PersonSetting[]): void {
    writer.writeInt(list.length)
    for (let i = 0; i < list.length; i++) {
        list[i]!.writeBin(writer)
    }
}

function readBubbleRegionList(reader: FileReader): BubbleRegion[] {
    const n = reader.readInt()
    const list: BubbleRegion[] = []
    for (let i = 0; i < n; i++) {
        const b = new BubbleRegion()
        b.readBin(reader)
        list.push(b)
    }
    return list
}

function writeBubbleRegionList(writer: FileWriter, list: BubbleRegion[]): void {
    writer.writeInt(list.length)
    for (let i = 0; i < list.length; i++) {
        list[i]!.writeBin(writer)
    }
}

class UserUseRember {
    public mid = ModuleId.userRm

    public BrowseMessage = false
    public NameList: NameOfColor[] = []
    public LastBubbleIndex = 1
    public Leftbubble = ''
    public Midbubble = ''
    public Rightbubble = ''
    public Picname: string[][] = []
    public ColorList: string[] = []
    public BeforeVarIndex = 0
    public BeforeVarExIndex = 0
    public BeforeStrIndex = 0
    public BeforeUniteIndex = 0
    public BeforeUniteVarIndex = 0
    public Speed = 1
    public LineNum = 0
    public Height = false
    public EventIndex = 0
    public NumberName: Hashtable = new Hashtable()
    public BubbleSytemRoleID = -1
    public BubbleRoleIdIndex = 0
    public BubbleImportPersonList: PersonSetting[] = []
    public BubbleRegionList: BubbleRegion[] = []
    public Compressfile: CompressFile = new CompressFile()
    public CompressAfterFile: CompressFile = new CompressFile()
    public BottomPicList: string[] = []
    public FaceWinShow = false
    public BPHeight = 0
    public FaceIsLeft = true
    public FontSelect = 0
    public FontSelectNew = ''
    public CurrentMaterialShowMode: number = MaterialShowMode.LargeIcon
    public TxtInputRowCol = ''
    public LastGamebinMD5 = ''
    public NumberNameList: NumberName[] = []

    constructor() {
        this.NameList = [new NameOfColor()]
        this.BrowseMessage = true
        this.ColorList = []
        this.Height = false
        this.LineNum = 60
        this.Compressfile = new CompressFile()
        this.CompressAfterFile = new CompressFile()
        this.BeforeVarIndex = 0
        this.BeforeVarExIndex = 0
        this.BeforeStrIndex = 0
        this.BottomPicList = ['']
        this.FaceWinShow = false
        this.BPHeight = 0
        this.FontSelect = 0
        this.FontSelectNew =
            '橙光官方方正字体,橙光官方汉仪字体,橙光官方理杏字体,用户本地字体'
        this.CurrentMaterialShowMode = MaterialShowMode.LargeIcon
        this.Leftbubble = ''
        this.Midbubble = ''
        this.Rightbubble = ''
        this.BubbleRoleIdIndex = 0
        this.BubbleSytemRoleID = -1
        this.TxtInputRowCol = ''
    }

    /**
     * 与 cg_v3 BaseDataStructure 装饰器顺序 1～34 一致
     */
    readBin(reader: FileReader): void {
        this.BrowseMessage = reader.readBool()
        this.NameList = readNameOfColorList(reader)
        this.LastBubbleIndex = reader.readInt()
        this.Leftbubble = reader.readString()
        this.Midbubble = reader.readString()
        this.Rightbubble = reader.readString()
        this.Picname = readStringMatrix(reader)
        this.ColorList = readStringList(reader)
        this.BeforeVarIndex = reader.readInt()
        this.BeforeVarExIndex = reader.readInt()
        this.BeforeStrIndex = reader.readInt()
        this.BeforeUniteIndex = reader.readInt()
        this.BeforeUniteVarIndex = reader.readInt()
        this.Speed = reader.readInt()
        this.LineNum = reader.readInt()
        this.Height = reader.readBool()
        this.EventIndex = reader.readInt()
        this.NumberName = new Hashtable()
        this.NumberName.readBin(reader)
        this.BubbleSytemRoleID = reader.readInt()
        this.BubbleRoleIdIndex = reader.readInt()
        this.BubbleImportPersonList = readPersonSettingList(reader)
        this.BubbleRegionList = readBubbleRegionList(reader)
        this.Compressfile = new CompressFile()
        this.Compressfile.readBin(reader)
        this.CompressAfterFile = new CompressFile()
        this.CompressAfterFile.readBin(reader)
        this.BottomPicList = readStringList(reader)
        this.FaceWinShow = reader.readBool()
        this.BPHeight = reader.readInt()
        this.FaceIsLeft = reader.readBool()
        this.FontSelect = reader.readInt()
        this.FontSelectNew = reader.readString()
        this.CurrentMaterialShowMode = reader.readInt()
        this.TxtInputRowCol = reader.readString()
        this.LastGamebinMD5 = reader.readString()

        this.NumberNameList = []
        if (DataUtils.dataVersion >= 108) {
            const nnLen = reader.readInt()
            for (let i = 0; i < nnLen; i++) {
                const nn = new NumberName()
                nn.readBin(reader)
                this.NumberNameList.push(nn)
                const o = this.NumberName as unknown as Record<string, unknown>
                o[String(nn.ID)] = nn.name
            }
        }
    }

    writeBin(writer: FileWriter): void {
        writer.writeBool(this.BrowseMessage)
        writeNameOfColorList(writer, this.NameList)
        writer.writeInt(this.LastBubbleIndex)
        writer.writeString(this.Leftbubble)
        writer.writeString(this.Midbubble)
        writer.writeString(this.Rightbubble)
        writeStringMatrix(writer, this.Picname)
        writeStringList(writer, this.ColorList)
        writer.writeInt(this.BeforeVarIndex)
        writer.writeInt(this.BeforeVarExIndex)
        writer.writeInt(this.BeforeStrIndex)
        writer.writeInt(this.BeforeUniteIndex)
        writer.writeInt(this.BeforeUniteVarIndex)
        writer.writeInt(this.Speed)
        writer.writeInt(this.LineNum)
        writer.writeBool(this.Height)
        writer.writeInt(this.EventIndex)
        this.NumberName.writeBin(writer)
        writer.writeInt(this.BubbleSytemRoleID)
        writer.writeInt(this.BubbleRoleIdIndex)
        writePersonSettingList(writer, this.BubbleImportPersonList)
        writeBubbleRegionList(writer, this.BubbleRegionList)
        this.Compressfile.writeBin(writer)
        this.CompressAfterFile.writeBin(writer)
        writeStringList(writer, this.BottomPicList)
        writer.writeBool(this.FaceWinShow)
        writer.writeInt(this.BPHeight)
        writer.writeBool(this.FaceIsLeft)
        writer.writeInt(this.FontSelect)
        writer.writeString(this.FontSelectNew)
        writer.writeInt(this.CurrentMaterialShowMode)
        writer.writeString(this.TxtInputRowCol)
        writer.writeString(this.LastGamebinMD5)

        if (DataUtils.dataVersion >= 108) {
            writer.writeInt(this.NumberNameList.length)
            for (let i = 0; i < this.NumberNameList.length; i++) {
                this.NumberNameList[i]!.writeBin(writer)
            }
        }
    }

}

export default UserUseRember
